import { createStyles, makeStyles, withStyles } from '@material-ui/core';
import { ButtonOne } from '../../../components/ButtonOne/ButtonOne.component';

export const useStyles = makeStyles(() =>
  createStyles({
    modalTitle: {
      marginTop: '26px',
      marginLeft: '28px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
      marginBottom: '28px',
    },
    menuItem: {
      '&:hover': {
        backgroundColor: '#CACAFC33',
        color: '#3C419A',
      },
    },
    formInput: {
      padding: '0px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      appearance: 'none',
    },
    formInputWidth: {
      width: '348px',
    },
    middleText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: '18px',
      color: '#2C2D3E',
    },
    numberCircleInline: {
      borderRadius: '50%',
      marginBottom: '28px',
      width: '30px',
      height: '30px',
      background: '#3C419A',
      color: '#FFFFFF',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesInline: {
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      marginTop: '4px',
      left: '63px',
      display: 'inline-block',
    },
    numberCircleOutline: {
      position: 'relative',
      borderRadius: '50%',
      left: '12px',
      marginBottom: '28px',
      width: '28px',
      height: '28px',
      border: '1px solid #3C419A',
      background: '#FFFFF',
      color: '#3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    numbersInCirclesOutline: {
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      marginTop: '4px',
      display: 'inline-block',
    },
    textInline: {
      position: 'relative',
      left: '9px',
      lineHeight: '16px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
      fontWeight: 'bold',
    },
    textOutline: {
      position: 'relative',
      left: '20px',
      lineHeight: '16px',
      fontSize: '13px',
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      display: 'inline-block',
      '& p': {
        margin: '0',
      },
    },
    line: {
      margin: '0px',
      marginRight: '42px',
      position: 'relative',
      left: '32px',
      top: '12px',
      width: '70px',
      height: '0px',
      size: '0px',
      color: '#2c2d3e',
      opacity: 0.4,
      display: 'inline-block',
      align: 'center',
    },
    centeredContainer: {
      textAlign: 'center',
      padding: '60px 200px',
    },
    paddedItem: {
      padding: '13px 10px',
    },
    checkOutline: {
      position: 'relative',
      borderRadius: '50%',
      marginBottom: '28px',
      width: '28px',
      height: '28px',
      background: '#FFFFFF',
      color: '#3C419A',
      border: '1px solid #3C419A',
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      lineHeight: '14px',
      display: 'inline-block',
      alignContent: 'center',
    },
    checkOutlineInside: {
      position: 'relative',
      fontSize: 12,
      fontFamily: 'Roboto',
      color: '#FFFFF',
      top: '2px',
      display: 'inline-block',
    },
    validationErrorText: {
      fontWeight: 400,
      fontSize: 15,
    },
    validationErrorTextBold: {
      fontWeight: 800,
      fontSize: 15,
      whiteSpace: 'break-spaces',
    },
  }),
);

export const CancelButton = withStyles(() => ({
  root: {
    width: '143px',
    padding: '0px 0px 0px 0px',
    height: '36px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
  },
}))(ButtonOne);

export const NextButton = withStyles(() => ({
  root: {
    width: '124px',
    padding: '0px 0px 0px 0px',
    height: '36px',
    border: 'solid 1px #3C419A',
    color: '#FFFFFF',
    backgroundColor: '#3C419A',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#3C419A',
      boxShadow: '0px 3px 1px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 1px rgba(0,0,0,0.12)',
    },
    '&:disabled': {
      backgroundColor: '#2C2D3E4D',
      color: '#FFFFFF',
      border: 'none',
    },
  },
}))(ButtonOne);
